import React from "react";
import styled from "styled-components";

const TextAreaContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 4px;
  width: 100%;
`;

const Label = styled.span`
  color: rgb(33, 37, 67);
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const TextAreaWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  border: solid 1px
    ${(props) => (props.error ? "rgb(220, 38, 38)" : "rgb(224, 228, 244)")};
  border-radius: 8px;
  background: rgb(255, 255, 255);
  padding: 8px 16px;
  transition: border-color 0.2s;

  &:focus-within {
    border-color: rgb(97, 98, 197);
  }
`;

const StyledTextArea = styled.textarea`
  flex: 1;
  border: none;
  outline: none;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  color: rgb(33, 37, 67);
  background: transparent;
  resize: vertical;
  min-height: 100px;
  width: 100%;

  &::placeholder {
    color: rgb(179, 182, 195);
  }
`;

const ErrorMessage = styled.span`
  color: rgb(220, 38, 38);
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  margin-top: 4px;
  text-align: left;
`;
const Required = styled.span`
  color: rgb(220, 38, 38);
  font-size: 12px;
  font-weight: 700;
  margin-left: 4px;
`;

const TextArea = ({
  label,
  placeholder,
  value,
  onChange,
  error,
  errorMessage,
  required,
  rows = 4,
  ...props
}) => {
  return (
    <TextAreaContainer>
      {label && <Label>{label} {required && <Required>*</Required>}</Label>}
      <TextAreaWrapper error={error}>
        <StyledTextArea
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          rows={rows}
          {...props}
        />
      </TextAreaWrapper>
      {error && errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </TextAreaContainer>
  );
};

export default TextArea;
